import { useContext } from "react";
import { PaymentContextProvider } from "./PaymentProvider";

export const usePayment = () => {
  const context = useContext(PaymentContextProvider);
  if (context === undefined) {
    throw new Error("usePayment must be used within a PaymentProvider");
  }
  return context;
};
